import React, { useEffect } from "react";
import { authme, displaySuccess } from "../../Utils/utils";
import { Link } from "react-router-dom";
import { toggleLoader } from "../../actions/loader";
import { connect } from "react-redux";
import { getUserData } from "../../actions/userdata";

const Topbar = (props) => {
  const logout = () => {
    localStorage.removeItem("token");
    displaySuccess("Logout Successfull");
    setTimeout(() => (window.location.href = "/"), 3000);
  };

  const toggleSidebar = (e) => {
    e.preventDefault();
    document.body.classList.toggle('sidebar-open');
  };

  const getAuthData = async () => {
    var res = await authme()
    props?.getUserData(res.data)
  }
  useEffect(() => {
    getAuthData()
  }, [])

  return (
    <>
      <nav className="navbar navbar-main border-bottom bg-primary">
        <div className="container-fluid py-1 px-3 d-flex align-items-center topbar-inner">
          {/* Hamburger — always visible on mobile, hidden on desktop */}
          <a
            href="#"
            className="nav-link p-0 mr-3 d-xl-none topbar-burger"
            onClick={toggleSidebar}
            style={{ lineHeight: 1 }}
          >
            <div className="sidenav-toggler-inner">
              <i className="sidenav-toggler-line" />
              <i className="sidenav-toggler-line" />
              <i className="sidenav-toggler-line" />
            </div>
          </a>

          {/* Hi Admin — visible on sm+ */}
          <div
            className="d-none d-sm-flex align-items-center text-white"
            style={{ fontSize: "16px", textTransform: "capitalize", fontWeight: 600 }}
          >
            <i className="fas fa-hand-sparkles" style={{ marginRight: 8, opacity: 0.9 }} />
            Hi, Admin
          </div>

          {/* Profile chip + Logout — pushed to the right */}
          <div className="ml-auto d-flex align-items-center topbar-actions" style={{ gap: 10 }}>
            <div
              className="d-flex align-items-center topbar-chip"
              style={{
                background: "rgba(255,255,255,0.18)",
                padding: "5px 12px 5px 5px",
                borderRadius: 999,
                backdropFilter: "blur(6px)",
              }}
            >
              <span
                style={{
                  width: 30,
                  height: 30,
                  borderRadius: "50%",
                  background: "#fff",
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginRight: 8,
                  boxShadow: "0 2px 6px rgba(0,0,0,0.12)",
                }}
              >
                <img src="/img/logo.png" width="20px" alt="logo" />
              </span>
              <span
                className="text-white"
                style={{ fontSize: 13, fontWeight: 600, letterSpacing: 0.2 }}
              >
                Admin
              </span>
            </div>
            <a
              onClick={logout}
              className="text-white d-flex align-items-center topbar-logout"
              style={{
                cursor: "pointer",
                fontSize: 13,
                fontWeight: 600,
                padding: "7px 14px",
                borderRadius: 999,
                background: "rgba(255,255,255,0.15)",
                gap: 6,
              }}
            >
              <i className="fas fa-sign-out-alt" />
              Log out
            </a>
          </div>
        </div>
      </nav>
    </>
  );
};
const mapDispatchToProps = {
  toggleLoader,
  getUserData,
};
const mapStateToProps = (state) => {
  return {
    userdata: state.userdata?.userData,
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Topbar);
